// import React from "react";
// import { getIn } from "formik";
// import FormControl from "@mui/material/FormControl";
// import InputLabel from "@mui/material/InputLabel";
// import Typography from "@mui/material/Typography";
// import TextField from "@mui/material/TextField";
// import Autocomplete from "@mui/material/Autocomplete";

// function FormAutoComplete({ field, form, label, options = [], isRequired, isLoading, onValueChange, nooptionText, bottomContent, ...props }) {
//     const [inputValue, setInputValue] = React.useState("");
//     const [open, setOpen] = React.useState(false);
//     const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);
//     const sortedOptions = React.useMemo(() => {
//         const seen = new Set();
//         return [...options]
//             .sort((a, b) => a.label.localeCompare(b.label))
//             .filter(option => {
//                 if (seen.has(option.id)) return false;
//                 seen.add(option.id);
//                 return true;
//             });
//     }, [options]);
//     // console.log(sortedOptions,"sortedOPtion")

//     return (
//         <FormControl fullWidth error={!!errorText}>
//             {field.name && (
//                 <InputLabel sx={{ ml: -1.6, textTransform: "capitalize" }} shrink htmlFor={field.name}>
//                     <Typography variant="body1">
//                         {label}
//                         {isRequired && (
//                             <Typography variant="body1" color="error" component="span">
//                                 {" *"}
//                             </Typography>
//                         )}
//                     </Typography>
//                 </InputLabel>
//             )}

//             <Autocomplete
//                 {...props}
//                 id={field.name}
//                 options={sortedOptions}
//                 filterOptions={(opts, { inputValue }) =>
//                     opts.filter(option => option.label.toLowerCase().includes(inputValue.toLowerCase()))
//                 }
//                 inputValue={inputValue}
//                 onInputChange={(_, newValue, reason) => {
//                     setInputValue(newValue);
//                     if (props.isShow && reason === 'input') {
//                         setOpen(newValue.length >= 3); // Only show after typing 3+ characters
//                     }
//                 }}

//                 //  onInputChange={(_, newValue, reason) => {
//                 //     setInputValue(newValue);
//                 //     if (props.isShow && reason === "input") {
//                 //         setOpen(newValue.length > 0);
//                 //     }
//                 // }}

//                 open={props.isShow ? open : undefined}
//                 onOpen={() => {
//                     if (!props.isShow) setOpen(true);
//                 }}
//                 onClose={() => {
//                     if (props.isShow) setOpen(false);
//                 }}
//                 noOptionsText={nooptionText}
//                 sx={{
//                     border: "0.5px solid #DC143C",
//                     borderRadius: "6px",
//                     mt: 2,
//                     "& fieldset": { border: "none" },
//                     "& .MuiOutlinedInput-root .MuiAutocomplete-input": { padding: "1px 0" },
//                     "& .MuiAutocomplete-endAdornment": {
//                         display: props.isShow ? "none !important" : "block !important",
//                     },
//                 }}
//                 onChange={(_, newValue) => {
//                     const selectedValue = newValue ? newValue.value : "";
//                     form.setFieldValue(field.name, selectedValue);
//                     if (onValueChange) {
//                         onValueChange(selectedValue, newValue?.id);
//                     }
//                 }}
//                 getOptionLabel={(option) => option.label || ""}
//                 isOptionEqualToValue={(option, val) => option.value === val}
//                 renderOption={(props, option) => (
//                     !isLoading ? (
//                         <li {...props} key={option.id}>
//                             <Typography variant="body1">{option.value}</Typography>
//                         </li>
//                     ) : (
//                         <li>
//                             <Typography variant="body1">...loading</Typography>
//                         </li>
//                     )
//                 )}
//                 renderInput={(params) => (
//                     <TextField
//                         label={undefined}
//                         name={field.name}
//                         {...params}
//                     />
//                 )}
//                 value={sortedOptions.find((option) => option.value === field.value) ?? null}
//             />
//             <Typography variant="body2" fontSize={"10px"} color="#DC143C" component="span">
//                 {errorText}
//             </Typography>
//         </FormControl>
//     );
// }

// export { FormAutoComplete };



import React from "react";
import { getIn } from "formik";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";

function FormAutoComplete({
    field,
    form,
    label,
    options = [],
    isRequired,
    isLoading,
    onValueChange,
    nooptionText,
    bottomContent, // ✅ custom JSX for bottom
    ...props
}) {
    const [inputValue, setInputValue] = React.useState("");
    const [open, setOpen] = React.useState(false);

    const errorText =
        getIn(form.touched, field.name) && getIn(form.errors, field.name);

    const sortedOptions = React.useMemo(() => {
        const seen = new Set();
        return [...options]
            .sort((a, b) => a.label.localeCompare(b.label))
            .filter((option) => {
                if (seen.has(option.id)) return false;
                seen.add(option.id);
                return true;
            });
    }, [options]);

    // ✅ Custom Listbox with bottomContent
    const CustomListbox = React.forwardRef(function CustomListbox(propsList, ref) {
        const { children, ...other } = propsList;
        return (
            <Box
                ref={ref}
                {...other}
                sx={{
                    maxHeight: 200,
                    overflow: "auto",
                    position: "relative",
                }}
            >
                {children}
                {bottomContent && (
                    <Box
                        sx={{
                            borderTop: "1px solid #eee",
                            background: "#fafafa",
                            p: 1,
                            textAlign: "center",
                            cursor: "pointer",
                            position: "sticky",
                            bottom: 0,
                        }}
                    >
                        {bottomContent}
                    </Box>
                )}
            </Box>
        );
    });

    React.useEffect(() => {
        if (props.value && props.value.value !== field.value) {
            form.setFieldValue(field.name, props.value.value);
        }
    }, [props.value, field.name, field.value, form]);
    
    return (
        <FormControl fullWidth error={!!errorText}>
            {field.name && (
                <InputLabel
                    sx={{ ml: -1.6, textTransform: "capitalize" }}
                    shrink
                    htmlFor={field.name}
                >
                    <Typography variant="body1">
                        {label}
                        {isRequired && (
                            <Typography variant="body1" color="error" component="span">
                                {" *"}
                            </Typography>
                        )}
                    </Typography>
                </InputLabel>
            )}

            <Autocomplete
                {...props}
                id={field.name}
                options={sortedOptions}
                filterOptions={(opts, { inputValue }) =>
                    opts.filter((option) =>
                        option.label.toLowerCase().includes(inputValue.toLowerCase())
                    )
                }
                inputValue={inputValue}
                onInputChange={(_, newValue, reason) => {
                    setInputValue(newValue);
                    if (props.isShow && reason === "input") {
                        setOpen(newValue.length >= 3);
                    }
                }}
                open={props.isShow ? open : undefined}
                onOpen={() => {
                    if (!props.isShow) setOpen(true);
                }}
                onClose={() => {
                    if (props.isShow) setOpen(false);
                }}
                noOptionsText={nooptionText}
                ListboxComponent={CustomListbox} // ✅ inject custom listbox
                sx={{
                    border: "0.5px solid #DC143C",
                    borderRadius: "6px",
                    mt: 2,
                    "& fieldset": { border: "none" },
                    "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
                        padding: "1px 0",
                    },
                    "& .MuiAutocomplete-endAdornment": {
                        display: props.isShow ? "none !important" : "block !important",
                    },
                }}
                // onChange={(_, newValue) => {
                //     const selectedValue = newValue ? newValue.value : "";
                //     form.setFieldValue(field.name, selectedValue);
                //     if (onValueChange) {
                //         onValueChange(selectedValue, newValue?.id);
                //     }
                // }}

                onChange={(_, newValue) => {
                    if (!newValue) {
                        // ⛔ User cleared selection
                        form.setFieldValue(field.name, "");
                        if (props.onValueChange) {
                            props.onValueChange("", null);
                        }
                        if (props.onClear) {
                            props.onClear(); // ✅ external clear handler
                        }
                        return;
                    }

                    const selectedValue = newValue.value;
                    form.setFieldValue(field.name, selectedValue);
                    if (onValueChange) {
                        onValueChange(selectedValue, newValue?.id);
                    }
                }}

                getOptionLabel={(option) => option.label || ""}
                isOptionEqualToValue={(option, val) => option.value === val}
                renderOption={(optionProps, option) =>
                    !isLoading ? (
                        <li {...optionProps} key={option.id}>
                            <Typography variant="body1">{option.value}</Typography>
                        </li>
                    ) : (
                        <li>
                            <Typography variant="body1">...loading</Typography>
                        </li>
                    )
                }
                renderInput={(params) => (
                    <TextField label={undefined} name={field.name} {...params} />
                )}
                // value={
                //     sortedOptions.find((option) => option.value === field.value) ?? null
                // }

                value={
                    sortedOptions.find((option) => option.value === field.value) ?? props.value ??
                    null
                }


            />

            <Typography
                variant="body2"
                fontSize={"10px"}
                color="#DC143C"
                component="span"
            >
                {errorText}
            </Typography>
        </FormControl>
    );
}

export { FormAutoComplete };


